import React from "react";
import PropTypes from "prop-types";
import "./Glory.css";
import { EventPics } from "./EventPics";

const GloryPage = () => {
  return (
    <div className="">
      <EventPics />
    </div>
  );
};

GloryPage.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  homePageReducer: PropTypes.object.isRequired,
};

export default GloryPage;
